var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "pta-documents" }, [
      _c("h1", [_vm._v("Documents")]),
      _vm._v(" "),
      _c("div", { staticClass: "pta-content-center" }, [
        _c("h2", [_vm._v("Upload your marketing materials")]),
        _vm._v(" "),
        _c("ul", { staticClass: "pta-documents" }, [
          _c("li", [_c("h3", [_vm._v("Fact Sheet")])]),
          _vm._v(" "),
          _c("li", [_c("h3", [_vm._v("Presentation")])]),
          _vm._v(" "),
          _c("li", [_c("h3", [_vm._v("Team Bios")])]),
          _vm._v(" "),
          _c("li", [_c("h3", [_vm._v("Case Studies")])]),
          _vm._v(" "),
          _c("li", [_c("h3", [_vm._v("FAQ/DDQ")])]),
          _vm._v(" "),
          _c("li", [_c("h3", [_vm._v("Track Record")])]),
          _vm._v(" "),
          _c("li", [_c("h3", [_vm._v("Financial Model")])]),
          _vm._v(" "),
          _c("li", [_c("h3", [_vm._v("Key Terms")])]),
          _vm._v(" "),
          _c("li", [_c("h3", [_vm._v("Market Reports")])]),
          _vm._v(" "),
          _c("li", [_c("h3", [_vm._v("Any other marketing materials")])]),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }